import { render, staticRenderFns } from "./CarouselBanner.vue?vue&type=template&id=04c9756a&scoped=true"
import script from "./CarouselBanner.vue?vue&type=script&lang=js"
export * from "./CarouselBanner.vue?vue&type=script&lang=js"
import style0 from "./CarouselBanner.vue?vue&type=style&index=0&id=04c9756a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c9756a",
  null
  
)

export default component.exports